export const random = (min, max) =>{
    return Math.floor(Math.random() * (max - min + 1) + min);
}
export const renderCommaFloat = value => value.toString().replace(".", ",")
